export const tabMenuScroll = (element) => {
    // Get the viewport width
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    // Set navbar offset
    let offset = document.querySelector('.site-header.sticky');
    offset = offset ? offset.offsetHeight : 0;

    if(vw <= 991) { //Breakpoint for TabPanel
        let finalOffset = element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
            top: finalOffset,
        });

    } else {

        var tabPanel = document.querySelector('.wp-block-rbt-tabpanel.active');
        if(tabPanel) {
          let finalOffset = tabPanel.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
              top: finalOffset,
              behavior: "smooth"
          });
        }
    }
}

export const doTabMenuClick = (e) => {
  e.preventDefault();
  var li = e.target.tagName === "LI" ? e.target : e.target.closest("li");
  var tabTargetID = li.getAttribute("data-tab-trigger");
  var tabTarget = document.getElementById(tabTargetID);
  var url = e.target.hasAttribute('href') ? e.target.getAttribute('href') : li.querySelector('a').getAttribute('href');
  //prettier entity encoding is preventing me from using && in a template literal :/
  if(tabTarget){
    if(url){
      var parent = tabTarget.closest(".rbt-tabpanels");
      var targets = parent.getElementsByClassName("q-tab-target");
      var controls = parent.getElementsByClassName("nav-tab");
      for(var i = 0; i < targets.length; i++){
        var target = targets[i];
        var tabLink = controls[i].querySelector('a');
        if(target === tabTarget){
            target.classList.add("active");
            controls[i].classList.add("active");
            if(tabLink) tabLink.setAttribute('aria-selected', 'true');
            /* Clone Node deep */
            var mobileContent = controls[i].querySelector('.mobile-content');
            if(!mobileContent){
              mobileContent = document.createElement('div');
              mobileContent.classList.add('mobile-content');
              mobileContent.innerHTML = target.innerHTML;
              controls[i].appendChild(mobileContent);
            }
        } else {
            target.classList.remove("active");
            controls[i].classList.remove("active");
            if(tabLink) tabLink.setAttribute('aria-selected', 'false');
            var mobileContent = controls[i].querySelectorAll('.mobile-content');
            if(mobileContent) mobileContent.forEach( item => {item.remove()} );
        }
      }
      window.history.pushState({}, document.title, url);
      console.log("Scrolling to tab", li);
      tabMenuScroll(li);
      /* Move focus into the newly active panel so AT users get the change announced */
      if(tabTarget.focus) tabTarget.focus({ preventScroll: true });
    }
  }
}
export const setTabPanels = () => {
    var tabPanels = document.querySelectorAll(".wp-block-rbt-tabpanel");
    if(!tabPanels[0]) return;
    /* A tab is already open (e.g. the theme's loadActiveTab() honoured a #/tab/ deep link) - don't open a second one */
    if(document.querySelector(".wp-block-rbt-tabpanel.active")) return;
    tabPanels[0].classList.add("active");
    /* Do mobile here */
    var navTarget = tabPanels[0].hasAttribute('data-control-target') ? tabPanels[0].getAttribute('data-control-target') : tabPanels[0].id;
    var navTargetId = 'ctrl-' + navTarget;
    var navTarget = document.getElementById(navTargetId);
    if(navTarget){
      let mobileContent = navTarget.querySelector('.mobile-content');
      if(!mobileContent){
        mobileContent = document.createElement('div');
        mobileContent.classList.add('mobile-content');
        mobileContent.innerHTML = tabPanels[0].innerHTML;
        navTarget.appendChild(mobileContent);
      }

    }
}
